import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { queryClient } from "@/lib/queryClient";
import { orpc, rpcClient } from "@/lib/rpc";

export interface UseRescheduleInterviewOptions {
  additionalInvalidateKeys?: string[][];
}

export function useRescheduleInterview(options: UseRescheduleInterviewOptions = {}) {
  const { toast } = useToast();
  const [rescheduleInterviewId, setRescheduleInterviewId] = useState<string | null>(null);
  const [isGroupInterview, setIsGroupInterview] = useState(false);

  const mutation = useMutation({
    mutationFn: async (interviewId: string) => {
      return rpcClient.interviews.reschedule({ id: interviewId });
    },
    onSuccess: (_data, _interviewId) => {
      toast({
        title: "Entrevista reagendada",
        description:
          "O agendamento foi cancelado. O candidato receberá um email de cancelamento com a opção de reagendar.",
      });
      queryClient.invalidateQueries({ queryKey: orpc.interviews.mine.queryOptions().queryKey });
      queryClient.invalidateQueries({ queryKey: orpc.applications.list.queryOptions().queryKey });
      for (const key of options.additionalInvalidateKeys || []) {
        queryClient.invalidateQueries({ queryKey: key });
      }
      setRescheduleInterviewId(null);
      setIsGroupInterview(false);
    },
    onError: (error: Error) => {
      toast({ title: "Erro ao reagendar", description: error.message, variant: "destructive" });
    },
  });

  const openReschedule = (interviewId: string, groupInterview = false) => {
    setRescheduleInterviewId(interviewId);
    setIsGroupInterview(groupInterview);
  };

  const closeReschedule = () => {
    setRescheduleInterviewId(null);
    setIsGroupInterview(false);
  };

  const confirmReschedule = () => {
    if (rescheduleInterviewId) {
      mutation.mutate(rescheduleInterviewId);
    }
  };

  return {
    rescheduleInterviewId,
    isGroupInterview,
    isPending: mutation.isPending,
    openReschedule,
    closeReschedule,
    confirmReschedule,
  };
}
